import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  NonNegativeInt: any;
  PositiveInt: any;
};

export type AdminGroup = {
  __typename?: 'AdminGroup';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  memberCount?: Maybe<Scalars['NonNegativeInt']>;
  members: Array<AdminUser>;
  name: Scalars['String'];
  resourceRoles?: Maybe<ResourceRoles>;
  updatedAt: Scalars['DateTime'];
};

export type AdminGroupAdminUserMutationInput = {
  adminGroupId: Scalars['String'];
  adminUserIds: Array<Scalars['String']>;
};

export type AdminGroupResourceRolesMutationInput = {
  adminGroupId: Scalars['String'];
  resourceRoles: ResourceRoleInput;
};

export type AdminGroupResourceRolesMutationResult = {
  __typename?: 'AdminGroupResourceRolesMutationResult';
  adminGroupId: Scalars['String'];
};

export type AdminGroupsResult = {
  __typename?: 'AdminGroupsResult';
  data: Array<AdminGroup>;
  meta: ResultMeta;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  adminAuthenticationProviderId: Scalars['String'];
  adminGroups: AdminGroupsResult;
  createdAt: Scalars['DateTime'];
  externalHumanReadableUsername: Scalars['String'];
  externalId: Scalars['String'];
  externalOrganizationId: Scalars['String'];
  externalRealName: Scalars['String'];
  globalRoles: Array<Scalars['String']>;
  id: Scalars['String'];
  isSuperadmin: Scalars['Boolean'];
  lastAuthenticatedAt?: Maybe<Scalars['DateTime']>;
};


export type AdminUserAdminGroupsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type AdminUsersResult = {
  __typename?: 'AdminUsersResult';
  data: Array<AdminUser>;
  meta: ResultMeta;
};

export type AssessmentOrder = {
  __typename?: 'AssessmentOrder';
  endTimestamp: Scalars['DateTime'];
  groups: Array<Group>;
  id: Scalars['String'];
  messages: Array<ScheduledMessage>;
  name: Scalars['String'];
  startTimestamp: Scalars['DateTime'];
  surveyMetaModules: Array<SurveyMetaModule>;
  users: UserResult;
};


export type AssessmentOrderUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type AssessmentOrdersResult = {
  __typename?: 'AssessmentOrdersResult';
  data: Array<AssessmentOrder>;
  meta: ResultMeta;
};

export type AvailableResourceRoles = {
  __typename?: 'AvailableResourceRoles';
  companyGroups: Array<Scalars['String']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CreateAdminGroupInput = {
  name: Scalars['String'];
};

export type CreateAssessmentOrderInput = {
  companyGroupIds: Array<Scalars['String']>;
  endTimestamp: Scalars['DateTime'];
  name: Scalars['String'];
  startTimestamp: Scalars['DateTime'];
  surveyModuleIds: Array<Scalars['String']>;
};

export type DeleteAdminGroupResult = {
  __typename?: 'DeleteAdminGroupResult';
  deletedAdminGroupId: Scalars['String'];
};

export type DeleteScheduledMessagesInput = {
  ids: Array<Scalars['PositiveInt']>;
};

export type DeleteScheduledMessagesResponse = {
  __typename?: 'DeleteScheduledMessagesResponse';
  ids: Array<Scalars['PositiveInt']>;
};

export type Group = {
  __typename?: 'Group';
  company: Scalars['String'];
  createdTimestamp: Scalars['DateTime'];
  creatorEmail: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  emailFilter?: Maybe<Scalars['String']>;
  endTimestamp: Scalars['DateTime'];
  id: Scalars['String'];
  modifiedTimestamp: Scalars['DateTime'];
  startTimestamp: Scalars['DateTime'];
  userCount: Scalars['Int'];
};

export type GroupResult = {
  __typename?: 'GroupResult';
  data: Array<Group>;
  meta: ResultMeta;
};

export type GroupRoleInput = {
  resourceId: Scalars['String'];
  roles: Array<Scalars['String']>;
};

export type GroupRoles = {
  __typename?: 'GroupRoles';
  resource: Group;
  resourceId: Scalars['String'];
  roles: Array<Scalars['String']>;
};

export type MessageRecipient = Group | User;

export type MsAdUser = {
  __typename?: 'MsAdUser';
  displayName: Scalars['String'];
  id: Scalars['String'];
  userPrincipalName: Scalars['String'];
};

export type MsAdUsersResult = {
  __typename?: 'MsAdUsersResult';
  data: Array<MsAdUser>;
  itemCountLimit: Scalars['NonNegativeInt'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addAdminUsersToAdminGroup: Array<AdminUser>;
  createAdminGroup: AdminGroup;
  createAdminUserFromMsAdUser: AdminUser;
  createAssessmentOrder: AssessmentOrder;
  createScheduledMessage: ScheduledMessage;
  deleteAdminGroup: DeleteAdminGroupResult;
  deleteScheduledMessages: DeleteScheduledMessagesResponse;
  grantResourceRolesToAdminGroup: AdminGroupResourceRolesMutationResult;
  removeAdminUsersFromAdminGroup: RemoveAdminUsersFromAdminGroupResult;
  revokeResourceRolesOfAdminGroup: AdminGroupResourceRolesMutationResult;
  updateAdminGroup: AdminGroup;
  updateAssessmentOrder: AssessmentOrder;
};


export type MutationAddAdminUsersToAdminGroupArgs = {
  input: AdminGroupAdminUserMutationInput;
};


export type MutationCreateAdminGroupArgs = {
  input: CreateAdminGroupInput;
};


export type MutationCreateAdminUserFromMsAdUserArgs = {
  msAdUserId: Scalars['String'];
};


export type MutationCreateAssessmentOrderArgs = {
  input: CreateAssessmentOrderInput;
};


export type MutationCreateScheduledMessageArgs = {
  input: ScheduledMessageInput;
};


export type MutationDeleteAdminGroupArgs = {
  id: Scalars['String'];
};


export type MutationDeleteScheduledMessagesArgs = {
  input: DeleteScheduledMessagesInput;
};


export type MutationGrantResourceRolesToAdminGroupArgs = {
  input: AdminGroupResourceRolesMutationInput;
};


export type MutationRemoveAdminUsersFromAdminGroupArgs = {
  input: AdminGroupAdminUserMutationInput;
};


export type MutationRevokeResourceRolesOfAdminGroupArgs = {
  input: AdminGroupResourceRolesMutationInput;
};


export type MutationUpdateAdminGroupArgs = {
  id: Scalars['String'];
  input: UpdateAdminGroupInput;
};


export type MutationUpdateAssessmentOrderArgs = {
  id: Scalars['String'];
  input: UpdateAssessmentOrderInput;
};

export type PaginationInput = {
  pageIndex: Scalars['NonNegativeInt'];
  pageSize: Scalars['PositiveInt'];
};

export type Query = {
  __typename?: 'Query';
  adminGroup: AdminGroup;
  adminGroups: AdminGroupsResult;
  adminUser: AdminUser;
  adminUsers: AdminUsersResult;
  assessmentOrder?: Maybe<AssessmentOrder>;
  assessmentOrders: AssessmentOrdersResult;
  availableResourceRoles: AvailableResourceRoles;
  group?: Maybe<Group>;
  groups: GroupResult;
  me: AdminUser;
  surveyMetaModules: SurveyMetaModuleResult;
  unlinkedMsAdUsersInAdAdminGroup: Array<MsAdUser>;
};


export type QueryAdminGroupArgs = {
  id: Scalars['String'];
};


export type QueryAdminGroupsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryAdminUserArgs = {
  id: Scalars['String'];
};


export type QueryAdminUsersArgs = {
  excludeMembersOfAdminGroup?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryAssessmentOrderArgs = {
  id: Scalars['String'];
};


export type QueryAssessmentOrdersArgs = {
  filter?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGroupArgs = {
  id: Scalars['String'];
};


export type QueryGroupsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QuerySurveyMetaModulesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type RemoveAdminUsersFromAdminGroupResult = {
  __typename?: 'RemoveAdminUsersFromAdminGroupResult';
  removedAdminUserIds: Array<Scalars['String']>;
};

export type ResourceRoleInput = {
  companyGroups?: InputMaybe<Array<GroupRoleInput>>;
};

export type ResourceRoles = {
  __typename?: 'ResourceRoles';
  companyGroups: Array<GroupRoles>;
};

export type ResultMeta = {
  __typename?: 'ResultMeta';
  totalResultCount: Scalars['NonNegativeInt'];
};

export type ScheduledMessage = {
  __typename?: 'ScheduledMessage';
  fired: Scalars['Boolean'];
  id?: Maybe<Scalars['PositiveInt']>;
  recipients: Array<MessageRecipient>;
  sendAfter: Scalars['DateTime'];
  type: ScheduledMessageType;
};

export type ScheduledMessageInput = {
  assessmentOrderId?: InputMaybe<Scalars['String']>;
  recipients: ScheduledMessageRecipientsInput;
  sendAfter?: InputMaybe<Scalars['DateTime']>;
  type: ScheduledMessageType;
};

export type ScheduledMessageRecipients = {
  __typename?: 'ScheduledMessageRecipients';
  groups: Array<Group>;
  users: Array<User>;
};

export type ScheduledMessageRecipientsInput = {
  groupIds: Array<Scalars['String']>;
  userUuids: Array<Scalars['String']>;
};

export enum ScheduledMessageType {
  EmailInvitation = 'EMAIL_INVITATION'
}

export type SortInput = {
  desc?: InputMaybe<Scalars['Boolean']>;
  sortBy: Scalars['String'];
};

export type SurveyMetaModule = {
  __typename?: 'SurveyMetaModule';
  id: Scalars['String'];
  nameT: Scalars['String'];
  sortKey: Scalars['Int'];
  surveyModules: Array<SurveyModule>;
};

export type SurveyMetaModuleResult = {
  __typename?: 'SurveyMetaModuleResult';
  data: Array<SurveyMetaModule>;
  meta: ResultMeta;
};

export type SurveyModule = {
  __typename?: 'SurveyModule';
  hidden: Scalars['Boolean'];
  id: Scalars['String'];
  nameT: Scalars['String'];
  sortKey: Scalars['Int'];
};

export type UpdateAdminGroupInput = {
  name: Scalars['String'];
};

export type UpdateAssessmentOrderInput = {
  endTimestamp: Scalars['DateTime'];
  name: Scalars['String'];
  startTimestamp: Scalars['DateTime'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type UserFilterInput = {
  assessmentOrderId?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};

export type UserResult = {
  __typename?: 'UserResult';
  data: Array<User>;
  meta: ResultMeta;
};

export type GroupFieldsFragment = { __typename?: 'Group', company: string, createdTimestamp: any, creatorEmail: string, department?: string | null, emailFilter?: string | null, endTimestamp: any, id: string, modifiedTimestamp: any, startTimestamp: any, userCount: number };

export type UserFieldsFragment = { __typename?: 'User', uuid: string, email: string, firstName?: string | null, lastName?: string | null, fullName?: string | null };

export type AddAdminUsersToAdminGroupMutationVariables = Exact<{
  input: AdminGroupAdminUserMutationInput;
}>;


export type AddAdminUsersToAdminGroupMutation = { __typename?: 'Mutation', addAdminUsersToAdminGroup: Array<{ __typename?: 'AdminUser', id: string }> };

export type CreateAdminGroupMutationVariables = Exact<{
  input: CreateAdminGroupInput;
}>;


export type CreateAdminGroupMutation = { __typename?: 'Mutation', createAdminGroup: { __typename?: 'AdminGroup', id: string } };

export type CreateAdminUserFromMsAdUserMutationVariables = Exact<{
  msAdUserId: Scalars['String'];
}>;


export type CreateAdminUserFromMsAdUserMutation = { __typename?: 'Mutation', createAdminUserFromMsAdUser: { __typename?: 'AdminUser', id: string } };

export type CreateAssessmentOrderMutationVariables = Exact<{
  input: CreateAssessmentOrderInput;
}>;


export type CreateAssessmentOrderMutation = { __typename?: 'Mutation', createAssessmentOrder: { __typename?: 'AssessmentOrder', id: string, name: string, startTimestamp: any, endTimestamp: any } };

export type CreateScheduledMessageMutationVariables = Exact<{
  input: ScheduledMessageInput;
}>;


export type CreateScheduledMessageMutation = { __typename?: 'Mutation', createScheduledMessage: { __typename?: 'ScheduledMessage', id?: any | null, sendAfter: any, fired: boolean, type: ScheduledMessageType, recipients: Array<{ __typename?: 'Group', company: string, id: string } | { __typename?: 'User', fullName?: string | null, uuid: string }> } };

export type DeleteScheduledMessagesMutationVariables = Exact<{
  input: DeleteScheduledMessagesInput;
}>;


export type DeleteScheduledMessagesMutation = { __typename?: 'Mutation', deleteScheduledMessages: { __typename?: 'DeleteScheduledMessagesResponse', ids: Array<any> } };

export type GetAdminGroupQueryVariables = Exact<{
  id: Scalars['String'];
  includeMembers: Scalars['Boolean'];
  includeResourceRoles: Scalars['Boolean'];
}>;


export type GetAdminGroupQuery = { __typename?: 'Query', adminGroup: { __typename?: 'AdminGroup', id: string, name: string, createdAt: any, updatedAt: any, memberCount?: any | null, members?: Array<{ __typename?: 'AdminUser', externalRealName: string, externalHumanReadableUsername: string, id: string, adminAuthenticationProviderId: string, externalId: string }>, resourceRoles?: { __typename?: 'ResourceRoles', companyGroups: Array<{ __typename?: 'GroupRoles', roles: Array<string>, resource: { __typename?: 'Group', id: string, company: string, department?: string | null } }> } | null } };

export type GetAdminGroupGroupRoleDataQueryVariables = Exact<{
  adminGroupId: Scalars['String'];
  groupId: Scalars['String'];
}>;


export type GetAdminGroupGroupRoleDataQuery = { __typename?: 'Query', adminGroup: { __typename?: 'AdminGroup', id: string, name: string, resourceRoles?: { __typename?: 'ResourceRoles', companyGroups: Array<{ __typename?: 'GroupRoles', resourceId: string, roles: Array<string> }> } | null }, group?: { __typename?: 'Group', company: string, department?: string | null, id: string } | null, availableResourceRoles: { __typename?: 'AvailableResourceRoles', companyGroups: Array<string> } };

export type GetAdminGroupsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<Scalars['String']>;
}>;


export type GetAdminGroupsQuery = { __typename?: 'Query', adminGroups: { __typename?: 'AdminGroupsResult', data: Array<{ __typename?: 'AdminGroup', id: string, name: string, memberCount?: any | null, createdAt: any, updatedAt: any }>, meta: { __typename?: 'ResultMeta', totalResultCount: any } } };

export type GetAdminUserQueryVariables = Exact<{
  id: Scalars['String'];
  includeGlobalRoles: Scalars['Boolean'];
  includeAdminGroups: Scalars['Boolean'];
}>;


export type GetAdminUserQuery = { __typename?: 'Query', adminUser: { __typename?: 'AdminUser', id: string, externalRealName: string, externalHumanReadableUsername: string, adminAuthenticationProviderId: string, externalOrganizationId: string, externalId: string, createdAt: any, lastAuthenticatedAt?: any | null, globalRoles?: Array<string>, isSuperadmin: boolean, adminGroups?: { __typename?: 'AdminGroupsResult', data: Array<{ __typename?: 'AdminGroup', id: string, name: string }> } } };

export type GetAdminUsersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<Scalars['String']>;
  excludeMembersOfAdminGroup?: InputMaybe<Scalars['String']>;
  includeGlobalRoles: Scalars['Boolean'];
  includeAdminGroups: Scalars['Boolean'];
}>;


export type GetAdminUsersQuery = { __typename?: 'Query', adminUsers: { __typename?: 'AdminUsersResult', data: Array<{ __typename?: 'AdminUser', id: string, externalRealName: string, externalHumanReadableUsername: string, adminAuthenticationProviderId: string, externalOrganizationId: string, createdAt: any, lastAuthenticatedAt?: any | null, globalRoles?: Array<string>, isSuperadmin: boolean, adminGroups?: { __typename?: 'AdminGroupsResult', data: Array<{ __typename?: 'AdminGroup', id: string, name: string }> } }>, meta: { __typename?: 'ResultMeta', totalResultCount: any } } };

export type GetAssessmentOrderQueryVariables = Exact<{
  id: Scalars['String'];
  usersPagination?: InputMaybe<PaginationInput>;
  usersSort?: InputMaybe<Array<SortInput> | SortInput>;
  usersFilter?: InputMaybe<UserFilterInput>;
}>;


export type GetAssessmentOrderQuery = { __typename?: 'Query', assessmentOrder?: { __typename?: 'AssessmentOrder', id: string, name: string, startTimestamp: any, endTimestamp: any, surveyMetaModules: Array<{ __typename?: 'SurveyMetaModule', id: string, nameT: string, sortKey: number, surveyModules: Array<{ __typename?: 'SurveyModule', id: string, nameT: string, sortKey: number, hidden: boolean }> }>, groups: Array<{ __typename?: 'Group', company: string, createdTimestamp: any, creatorEmail: string, department?: string | null, emailFilter?: string | null, endTimestamp: any, id: string, modifiedTimestamp: any, startTimestamp: any, userCount: number }>, messages: Array<{ __typename?: 'ScheduledMessage', id?: any | null, sendAfter: any, fired: boolean, type: ScheduledMessageType, recipients: Array<{ __typename?: 'Group', company: string, createdTimestamp: any, creatorEmail: string, department?: string | null, emailFilter?: string | null, endTimestamp: any, id: string, modifiedTimestamp: any, startTimestamp: any, userCount: number } | { __typename?: 'User', uuid: string, email: string, firstName?: string | null, lastName?: string | null, fullName?: string | null }> }>, users: { __typename?: 'UserResult', data: Array<{ __typename?: 'User', uuid: string, email: string, firstName?: string | null, lastName?: string | null, fullName?: string | null }>, meta: { __typename?: 'ResultMeta', totalResultCount: any } } } | null };

export type GetAssessmentOrdersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<Scalars['String']>;
}>;


export type GetAssessmentOrdersQuery = { __typename?: 'Query', assessmentOrders: { __typename?: 'AssessmentOrdersResult', data: Array<{ __typename?: 'AssessmentOrder', id: string, name: string, startTimestamp: any, endTimestamp: any, groups: Array<{ __typename?: 'Group', id: string, company: string }> }>, meta: { __typename?: 'ResultMeta', totalResultCount: any } } };

export type GetGroupsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<Scalars['String']>;
}>;


export type GetGroupsQuery = { __typename?: 'Query', groups: { __typename?: 'GroupResult', data: Array<{ __typename?: 'Group', company: string, createdTimestamp: any, department?: string | null, id: string, startTimestamp: any, userCount: number }>, meta: { __typename?: 'ResultMeta', totalResultCount: any } } };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me: { __typename?: 'AdminUser', isSuperadmin: boolean } };

export type GetSurveyMetaModulesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetSurveyMetaModulesQuery = { __typename?: 'Query', surveyMetaModules: { __typename?: 'SurveyMetaModuleResult', data: Array<{ __typename?: 'SurveyMetaModule', id: string, nameT: string, surveyModules: Array<{ __typename?: 'SurveyModule', id: string, nameT: string, hidden: boolean }> }>, meta: { __typename?: 'ResultMeta', totalResultCount: any } } };

export type GetUnlinkedMsAdUsersInAdAdminGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnlinkedMsAdUsersInAdAdminGroupQuery = { __typename?: 'Query', unlinkedMsAdUsersInAdAdminGroup: Array<{ __typename?: 'MsAdUser', id: string, userPrincipalName: string, displayName: string }> };

export type GrantResourceRolesToAdminGroupMutationVariables = Exact<{
  input: AdminGroupResourceRolesMutationInput;
}>;


export type GrantResourceRolesToAdminGroupMutation = { __typename?: 'Mutation', grantResourceRolesToAdminGroup: { __typename?: 'AdminGroupResourceRolesMutationResult', adminGroupId: string } };

export type RemoveAdminUsersFromAdminGroupMutationVariables = Exact<{
  input: AdminGroupAdminUserMutationInput;
}>;


export type RemoveAdminUsersFromAdminGroupMutation = { __typename?: 'Mutation', removeAdminUsersFromAdminGroup: { __typename?: 'RemoveAdminUsersFromAdminGroupResult', removedAdminUserIds: Array<string> } };

export type RevokeResourceRolesOfAdminGroupMutationVariables = Exact<{
  input: AdminGroupResourceRolesMutationInput;
}>;


export type RevokeResourceRolesOfAdminGroupMutation = { __typename?: 'Mutation', revokeResourceRolesOfAdminGroup: { __typename?: 'AdminGroupResourceRolesMutationResult', adminGroupId: string } };

export type UpdateAdminGroupMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateAdminGroupInput;
}>;


export type UpdateAdminGroupMutation = { __typename?: 'Mutation', updateAdminGroup: { __typename?: 'AdminGroup', name: string } };

export type UpdateAssessmentOrderMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateAssessmentOrderInput;
}>;


export type UpdateAssessmentOrderMutation = { __typename?: 'Mutation', updateAssessmentOrder: { __typename?: 'AssessmentOrder', id: string, name: string, startTimestamp: any, endTimestamp: any } };

export const GroupFieldsFragmentDoc = gql`
    fragment GroupFields on Group {
  company
  createdTimestamp
  creatorEmail
  department
  emailFilter
  endTimestamp
  id
  modifiedTimestamp
  startTimestamp
  userCount
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  uuid
  email
  firstName
  lastName
  fullName
}
    `;
export const AddAdminUsersToAdminGroupDocument = gql`
    mutation AddAdminUsersToAdminGroup($input: AdminGroupAdminUserMutationInput!) {
  addAdminUsersToAdminGroup(input: $input) {
    id
  }
}
    `;
export type AddAdminUsersToAdminGroupMutationFn = Apollo.MutationFunction<AddAdminUsersToAdminGroupMutation, AddAdminUsersToAdminGroupMutationVariables>;

/**
 * __useAddAdminUsersToAdminGroupMutation__
 *
 * To run a mutation, you first call `useAddAdminUsersToAdminGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdminUsersToAdminGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdminUsersToAdminGroupMutation, { data, loading, error }] = useAddAdminUsersToAdminGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAdminUsersToAdminGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddAdminUsersToAdminGroupMutation, AddAdminUsersToAdminGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAdminUsersToAdminGroupMutation, AddAdminUsersToAdminGroupMutationVariables>(AddAdminUsersToAdminGroupDocument, options);
      }
export type AddAdminUsersToAdminGroupMutationHookResult = ReturnType<typeof useAddAdminUsersToAdminGroupMutation>;
export type AddAdminUsersToAdminGroupMutationResult = Apollo.MutationResult<AddAdminUsersToAdminGroupMutation>;
export type AddAdminUsersToAdminGroupMutationOptions = Apollo.BaseMutationOptions<AddAdminUsersToAdminGroupMutation, AddAdminUsersToAdminGroupMutationVariables>;
export const CreateAdminGroupDocument = gql`
    mutation CreateAdminGroup($input: CreateAdminGroupInput!) {
  createAdminGroup(input: $input) {
    id
  }
}
    `;
export type CreateAdminGroupMutationFn = Apollo.MutationFunction<CreateAdminGroupMutation, CreateAdminGroupMutationVariables>;

/**
 * __useCreateAdminGroupMutation__
 *
 * To run a mutation, you first call `useCreateAdminGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminGroupMutation, { data, loading, error }] = useCreateAdminGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminGroupMutation, CreateAdminGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminGroupMutation, CreateAdminGroupMutationVariables>(CreateAdminGroupDocument, options);
      }
export type CreateAdminGroupMutationHookResult = ReturnType<typeof useCreateAdminGroupMutation>;
export type CreateAdminGroupMutationResult = Apollo.MutationResult<CreateAdminGroupMutation>;
export type CreateAdminGroupMutationOptions = Apollo.BaseMutationOptions<CreateAdminGroupMutation, CreateAdminGroupMutationVariables>;
export const CreateAdminUserFromMsAdUserDocument = gql`
    mutation CreateAdminUserFromMsAdUser($msAdUserId: String!) {
  createAdminUserFromMsAdUser(msAdUserId: $msAdUserId) {
    id
  }
}
    `;
export type CreateAdminUserFromMsAdUserMutationFn = Apollo.MutationFunction<CreateAdminUserFromMsAdUserMutation, CreateAdminUserFromMsAdUserMutationVariables>;

/**
 * __useCreateAdminUserFromMsAdUserMutation__
 *
 * To run a mutation, you first call `useCreateAdminUserFromMsAdUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminUserFromMsAdUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminUserFromMsAdUserMutation, { data, loading, error }] = useCreateAdminUserFromMsAdUserMutation({
 *   variables: {
 *      msAdUserId: // value for 'msAdUserId'
 *   },
 * });
 */
export function useCreateAdminUserFromMsAdUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminUserFromMsAdUserMutation, CreateAdminUserFromMsAdUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminUserFromMsAdUserMutation, CreateAdminUserFromMsAdUserMutationVariables>(CreateAdminUserFromMsAdUserDocument, options);
      }
export type CreateAdminUserFromMsAdUserMutationHookResult = ReturnType<typeof useCreateAdminUserFromMsAdUserMutation>;
export type CreateAdminUserFromMsAdUserMutationResult = Apollo.MutationResult<CreateAdminUserFromMsAdUserMutation>;
export type CreateAdminUserFromMsAdUserMutationOptions = Apollo.BaseMutationOptions<CreateAdminUserFromMsAdUserMutation, CreateAdminUserFromMsAdUserMutationVariables>;
export const CreateAssessmentOrderDocument = gql`
    mutation CreateAssessmentOrder($input: CreateAssessmentOrderInput!) {
  createAssessmentOrder(input: $input) {
    id
    name
    startTimestamp
    endTimestamp
  }
}
    `;
export type CreateAssessmentOrderMutationFn = Apollo.MutationFunction<CreateAssessmentOrderMutation, CreateAssessmentOrderMutationVariables>;

/**
 * __useCreateAssessmentOrderMutation__
 *
 * To run a mutation, you first call `useCreateAssessmentOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssessmentOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssessmentOrderMutation, { data, loading, error }] = useCreateAssessmentOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssessmentOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssessmentOrderMutation, CreateAssessmentOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssessmentOrderMutation, CreateAssessmentOrderMutationVariables>(CreateAssessmentOrderDocument, options);
      }
export type CreateAssessmentOrderMutationHookResult = ReturnType<typeof useCreateAssessmentOrderMutation>;
export type CreateAssessmentOrderMutationResult = Apollo.MutationResult<CreateAssessmentOrderMutation>;
export type CreateAssessmentOrderMutationOptions = Apollo.BaseMutationOptions<CreateAssessmentOrderMutation, CreateAssessmentOrderMutationVariables>;
export const CreateScheduledMessageDocument = gql`
    mutation CreateScheduledMessage($input: ScheduledMessageInput!) {
  createScheduledMessage(input: $input) {
    id
    sendAfter
    fired
    type
    recipients {
      ... on Group {
        company
        id
      }
      ... on User {
        fullName
        uuid
      }
    }
  }
}
    `;
export type CreateScheduledMessageMutationFn = Apollo.MutationFunction<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>;

/**
 * __useCreateScheduledMessageMutation__
 *
 * To run a mutation, you first call `useCreateScheduledMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduledMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduledMessageMutation, { data, loading, error }] = useCreateScheduledMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduledMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>(CreateScheduledMessageDocument, options);
      }
export type CreateScheduledMessageMutationHookResult = ReturnType<typeof useCreateScheduledMessageMutation>;
export type CreateScheduledMessageMutationResult = Apollo.MutationResult<CreateScheduledMessageMutation>;
export type CreateScheduledMessageMutationOptions = Apollo.BaseMutationOptions<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>;
export const DeleteScheduledMessagesDocument = gql`
    mutation DeleteScheduledMessages($input: DeleteScheduledMessagesInput!) {
  deleteScheduledMessages(input: $input) {
    ids
  }
}
    `;
export type DeleteScheduledMessagesMutationFn = Apollo.MutationFunction<DeleteScheduledMessagesMutation, DeleteScheduledMessagesMutationVariables>;

/**
 * __useDeleteScheduledMessagesMutation__
 *
 * To run a mutation, you first call `useDeleteScheduledMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduledMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduledMessagesMutation, { data, loading, error }] = useDeleteScheduledMessagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteScheduledMessagesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduledMessagesMutation, DeleteScheduledMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduledMessagesMutation, DeleteScheduledMessagesMutationVariables>(DeleteScheduledMessagesDocument, options);
      }
export type DeleteScheduledMessagesMutationHookResult = ReturnType<typeof useDeleteScheduledMessagesMutation>;
export type DeleteScheduledMessagesMutationResult = Apollo.MutationResult<DeleteScheduledMessagesMutation>;
export type DeleteScheduledMessagesMutationOptions = Apollo.BaseMutationOptions<DeleteScheduledMessagesMutation, DeleteScheduledMessagesMutationVariables>;
export const GetAdminGroupDocument = gql`
    query GetAdminGroup($id: String!, $includeMembers: Boolean!, $includeResourceRoles: Boolean!) {
  adminGroup(id: $id) {
    id
    name
    createdAt
    updatedAt
    members @include(if: $includeMembers) {
      externalRealName
      externalHumanReadableUsername
      id
      adminAuthenticationProviderId
      externalId
    }
    memberCount @include(if: $includeMembers)
    resourceRoles @include(if: $includeResourceRoles) {
      companyGroups {
        roles
        resource {
          id
          company
          department
        }
      }
    }
  }
}
    `;

/**
 * __useGetAdminGroupQuery__
 *
 * To run a query within a React component, call `useGetAdminGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeMembers: // value for 'includeMembers'
 *      includeResourceRoles: // value for 'includeResourceRoles'
 *   },
 * });
 */
export function useGetAdminGroupQuery(baseOptions: Apollo.QueryHookOptions<GetAdminGroupQuery, GetAdminGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminGroupQuery, GetAdminGroupQueryVariables>(GetAdminGroupDocument, options);
      }
export function useGetAdminGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminGroupQuery, GetAdminGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminGroupQuery, GetAdminGroupQueryVariables>(GetAdminGroupDocument, options);
        }
export type GetAdminGroupQueryHookResult = ReturnType<typeof useGetAdminGroupQuery>;
export type GetAdminGroupLazyQueryHookResult = ReturnType<typeof useGetAdminGroupLazyQuery>;
export type GetAdminGroupQueryResult = Apollo.QueryResult<GetAdminGroupQuery, GetAdminGroupQueryVariables>;
export const GetAdminGroupGroupRoleDataDocument = gql`
    query GetAdminGroupGroupRoleData($adminGroupId: String!, $groupId: String!) {
  adminGroup(id: $adminGroupId) {
    id
    name
    resourceRoles {
      companyGroups {
        resourceId
        roles
      }
    }
  }
  group(id: $groupId) {
    company
    department
    id
  }
  availableResourceRoles {
    companyGroups
  }
}
    `;

/**
 * __useGetAdminGroupGroupRoleDataQuery__
 *
 * To run a query within a React component, call `useGetAdminGroupGroupRoleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminGroupGroupRoleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminGroupGroupRoleDataQuery({
 *   variables: {
 *      adminGroupId: // value for 'adminGroupId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetAdminGroupGroupRoleDataQuery(baseOptions: Apollo.QueryHookOptions<GetAdminGroupGroupRoleDataQuery, GetAdminGroupGroupRoleDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminGroupGroupRoleDataQuery, GetAdminGroupGroupRoleDataQueryVariables>(GetAdminGroupGroupRoleDataDocument, options);
      }
export function useGetAdminGroupGroupRoleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminGroupGroupRoleDataQuery, GetAdminGroupGroupRoleDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminGroupGroupRoleDataQuery, GetAdminGroupGroupRoleDataQueryVariables>(GetAdminGroupGroupRoleDataDocument, options);
        }
export type GetAdminGroupGroupRoleDataQueryHookResult = ReturnType<typeof useGetAdminGroupGroupRoleDataQuery>;
export type GetAdminGroupGroupRoleDataLazyQueryHookResult = ReturnType<typeof useGetAdminGroupGroupRoleDataLazyQuery>;
export type GetAdminGroupGroupRoleDataQueryResult = Apollo.QueryResult<GetAdminGroupGroupRoleDataQuery, GetAdminGroupGroupRoleDataQueryVariables>;
export const GetAdminGroupsDocument = gql`
    query GetAdminGroups($pagination: PaginationInput, $sort: [SortInput!], $filter: String) {
  adminGroups(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      id
      name
      memberCount
      createdAt
      updatedAt
    }
    meta {
      totalResultCount
    }
  }
}
    `;

/**
 * __useGetAdminGroupsQuery__
 *
 * To run a query within a React component, call `useGetAdminGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAdminGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminGroupsQuery, GetAdminGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminGroupsQuery, GetAdminGroupsQueryVariables>(GetAdminGroupsDocument, options);
      }
export function useGetAdminGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminGroupsQuery, GetAdminGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminGroupsQuery, GetAdminGroupsQueryVariables>(GetAdminGroupsDocument, options);
        }
export type GetAdminGroupsQueryHookResult = ReturnType<typeof useGetAdminGroupsQuery>;
export type GetAdminGroupsLazyQueryHookResult = ReturnType<typeof useGetAdminGroupsLazyQuery>;
export type GetAdminGroupsQueryResult = Apollo.QueryResult<GetAdminGroupsQuery, GetAdminGroupsQueryVariables>;
export const GetAdminUserDocument = gql`
    query GetAdminUser($id: String!, $includeGlobalRoles: Boolean!, $includeAdminGroups: Boolean!) {
  adminUser(id: $id) {
    id
    externalRealName
    externalHumanReadableUsername
    adminAuthenticationProviderId
    externalOrganizationId
    externalId
    createdAt
    lastAuthenticatedAt
    globalRoles @include(if: $includeGlobalRoles)
    adminGroups @include(if: $includeAdminGroups) {
      data {
        id
        name
      }
    }
    isSuperadmin
  }
}
    `;

/**
 * __useGetAdminUserQuery__
 *
 * To run a query within a React component, call `useGetAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeGlobalRoles: // value for 'includeGlobalRoles'
 *      includeAdminGroups: // value for 'includeAdminGroups'
 *   },
 * });
 */
export function useGetAdminUserQuery(baseOptions: Apollo.QueryHookOptions<GetAdminUserQuery, GetAdminUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUserQuery, GetAdminUserQueryVariables>(GetAdminUserDocument, options);
      }
export function useGetAdminUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUserQuery, GetAdminUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUserQuery, GetAdminUserQueryVariables>(GetAdminUserDocument, options);
        }
export type GetAdminUserQueryHookResult = ReturnType<typeof useGetAdminUserQuery>;
export type GetAdminUserLazyQueryHookResult = ReturnType<typeof useGetAdminUserLazyQuery>;
export type GetAdminUserQueryResult = Apollo.QueryResult<GetAdminUserQuery, GetAdminUserQueryVariables>;
export const GetAdminUsersDocument = gql`
    query GetAdminUsers($pagination: PaginationInput, $sort: [SortInput!], $filter: String, $excludeMembersOfAdminGroup: String, $includeGlobalRoles: Boolean!, $includeAdminGroups: Boolean!) {
  adminUsers(
    pagination: $pagination
    sort: $sort
    filter: $filter
    excludeMembersOfAdminGroup: $excludeMembersOfAdminGroup
  ) {
    data {
      id
      externalRealName
      externalHumanReadableUsername
      adminAuthenticationProviderId
      externalOrganizationId
      createdAt
      lastAuthenticatedAt
      globalRoles @include(if: $includeGlobalRoles)
      adminGroups @include(if: $includeAdminGroups) {
        data {
          id
          name
        }
      }
      isSuperadmin
    }
    meta {
      totalResultCount
    }
  }
}
    `;

/**
 * __useGetAdminUsersQuery__
 *
 * To run a query within a React component, call `useGetAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      excludeMembersOfAdminGroup: // value for 'excludeMembersOfAdminGroup'
 *      includeGlobalRoles: // value for 'includeGlobalRoles'
 *      includeAdminGroups: // value for 'includeAdminGroups'
 *   },
 * });
 */
export function useGetAdminUsersQuery(baseOptions: Apollo.QueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
      }
export function useGetAdminUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
        }
export type GetAdminUsersQueryHookResult = ReturnType<typeof useGetAdminUsersQuery>;
export type GetAdminUsersLazyQueryHookResult = ReturnType<typeof useGetAdminUsersLazyQuery>;
export type GetAdminUsersQueryResult = Apollo.QueryResult<GetAdminUsersQuery, GetAdminUsersQueryVariables>;
export const GetAssessmentOrderDocument = gql`
    query GetAssessmentOrder($id: String!, $usersPagination: PaginationInput, $usersSort: [SortInput!], $usersFilter: UserFilterInput) {
  assessmentOrder(id: $id) {
    id
    name
    startTimestamp
    endTimestamp
    surveyMetaModules {
      id
      nameT
      sortKey
      surveyModules {
        id
        nameT
        sortKey
        hidden
      }
    }
    groups {
      ...GroupFields
    }
    messages {
      id
      sendAfter
      fired
      type
      recipients {
        ... on Group {
          ...GroupFields
        }
        ... on User {
          ...UserFields
        }
      }
    }
    users(pagination: $usersPagination, sort: $usersSort, filter: $usersFilter) {
      data {
        ...UserFields
      }
      meta {
        totalResultCount
      }
    }
  }
}
    ${GroupFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

/**
 * __useGetAssessmentOrderQuery__
 *
 * To run a query within a React component, call `useGetAssessmentOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      usersPagination: // value for 'usersPagination'
 *      usersSort: // value for 'usersSort'
 *      usersFilter: // value for 'usersFilter'
 *   },
 * });
 */
export function useGetAssessmentOrderQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentOrderQuery, GetAssessmentOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentOrderQuery, GetAssessmentOrderQueryVariables>(GetAssessmentOrderDocument, options);
      }
export function useGetAssessmentOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentOrderQuery, GetAssessmentOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentOrderQuery, GetAssessmentOrderQueryVariables>(GetAssessmentOrderDocument, options);
        }
export type GetAssessmentOrderQueryHookResult = ReturnType<typeof useGetAssessmentOrderQuery>;
export type GetAssessmentOrderLazyQueryHookResult = ReturnType<typeof useGetAssessmentOrderLazyQuery>;
export type GetAssessmentOrderQueryResult = Apollo.QueryResult<GetAssessmentOrderQuery, GetAssessmentOrderQueryVariables>;
export const GetAssessmentOrdersDocument = gql`
    query GetAssessmentOrders($pagination: PaginationInput, $sort: [SortInput!], $filter: String) {
  assessmentOrders(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      id
      name
      startTimestamp
      endTimestamp
      groups {
        id
        company
      }
    }
    meta {
      totalResultCount
    }
  }
}
    `;

/**
 * __useGetAssessmentOrdersQuery__
 *
 * To run a query within a React component, call `useGetAssessmentOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentOrdersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAssessmentOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetAssessmentOrdersQuery, GetAssessmentOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentOrdersQuery, GetAssessmentOrdersQueryVariables>(GetAssessmentOrdersDocument, options);
      }
export function useGetAssessmentOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentOrdersQuery, GetAssessmentOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentOrdersQuery, GetAssessmentOrdersQueryVariables>(GetAssessmentOrdersDocument, options);
        }
export type GetAssessmentOrdersQueryHookResult = ReturnType<typeof useGetAssessmentOrdersQuery>;
export type GetAssessmentOrdersLazyQueryHookResult = ReturnType<typeof useGetAssessmentOrdersLazyQuery>;
export type GetAssessmentOrdersQueryResult = Apollo.QueryResult<GetAssessmentOrdersQuery, GetAssessmentOrdersQueryVariables>;
export const GetGroupsDocument = gql`
    query GetGroups($pagination: PaginationInput, $sort: [SortInput!], $filter: String) {
  groups(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      company
      createdTimestamp
      department
      id
      startTimestamp
      userCount
    }
    meta {
      totalResultCount
    }
  }
}
    `;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
      }
export function useGetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsQueryResult = Apollo.QueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetMeDocument = gql`
    query GetMe {
  me {
    isSuperadmin
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetSurveyMetaModulesDocument = gql`
    query GetSurveyMetaModules($pagination: PaginationInput, $sort: [SortInput!]) {
  surveyMetaModules(pagination: $pagination, sort: $sort) {
    data {
      id
      nameT
      surveyModules {
        id
        nameT
        hidden
      }
    }
    meta {
      totalResultCount
    }
  }
}
    `;

/**
 * __useGetSurveyMetaModulesQuery__
 *
 * To run a query within a React component, call `useGetSurveyMetaModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyMetaModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyMetaModulesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetSurveyMetaModulesQuery(baseOptions?: Apollo.QueryHookOptions<GetSurveyMetaModulesQuery, GetSurveyMetaModulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyMetaModulesQuery, GetSurveyMetaModulesQueryVariables>(GetSurveyMetaModulesDocument, options);
      }
export function useGetSurveyMetaModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyMetaModulesQuery, GetSurveyMetaModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyMetaModulesQuery, GetSurveyMetaModulesQueryVariables>(GetSurveyMetaModulesDocument, options);
        }
export type GetSurveyMetaModulesQueryHookResult = ReturnType<typeof useGetSurveyMetaModulesQuery>;
export type GetSurveyMetaModulesLazyQueryHookResult = ReturnType<typeof useGetSurveyMetaModulesLazyQuery>;
export type GetSurveyMetaModulesQueryResult = Apollo.QueryResult<GetSurveyMetaModulesQuery, GetSurveyMetaModulesQueryVariables>;
export const GetUnlinkedMsAdUsersInAdAdminGroupDocument = gql`
    query GetUnlinkedMsAdUsersInAdAdminGroup {
  unlinkedMsAdUsersInAdAdminGroup {
    id
    userPrincipalName
    displayName
  }
}
    `;

/**
 * __useGetUnlinkedMsAdUsersInAdAdminGroupQuery__
 *
 * To run a query within a React component, call `useGetUnlinkedMsAdUsersInAdAdminGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnlinkedMsAdUsersInAdAdminGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnlinkedMsAdUsersInAdAdminGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnlinkedMsAdUsersInAdAdminGroupQuery(baseOptions?: Apollo.QueryHookOptions<GetUnlinkedMsAdUsersInAdAdminGroupQuery, GetUnlinkedMsAdUsersInAdAdminGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnlinkedMsAdUsersInAdAdminGroupQuery, GetUnlinkedMsAdUsersInAdAdminGroupQueryVariables>(GetUnlinkedMsAdUsersInAdAdminGroupDocument, options);
      }
export function useGetUnlinkedMsAdUsersInAdAdminGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnlinkedMsAdUsersInAdAdminGroupQuery, GetUnlinkedMsAdUsersInAdAdminGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnlinkedMsAdUsersInAdAdminGroupQuery, GetUnlinkedMsAdUsersInAdAdminGroupQueryVariables>(GetUnlinkedMsAdUsersInAdAdminGroupDocument, options);
        }
export type GetUnlinkedMsAdUsersInAdAdminGroupQueryHookResult = ReturnType<typeof useGetUnlinkedMsAdUsersInAdAdminGroupQuery>;
export type GetUnlinkedMsAdUsersInAdAdminGroupLazyQueryHookResult = ReturnType<typeof useGetUnlinkedMsAdUsersInAdAdminGroupLazyQuery>;
export type GetUnlinkedMsAdUsersInAdAdminGroupQueryResult = Apollo.QueryResult<GetUnlinkedMsAdUsersInAdAdminGroupQuery, GetUnlinkedMsAdUsersInAdAdminGroupQueryVariables>;
export const GrantResourceRolesToAdminGroupDocument = gql`
    mutation GrantResourceRolesToAdminGroup($input: AdminGroupResourceRolesMutationInput!) {
  grantResourceRolesToAdminGroup(input: $input) {
    adminGroupId
  }
}
    `;
export type GrantResourceRolesToAdminGroupMutationFn = Apollo.MutationFunction<GrantResourceRolesToAdminGroupMutation, GrantResourceRolesToAdminGroupMutationVariables>;

/**
 * __useGrantResourceRolesToAdminGroupMutation__
 *
 * To run a mutation, you first call `useGrantResourceRolesToAdminGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantResourceRolesToAdminGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantResourceRolesToAdminGroupMutation, { data, loading, error }] = useGrantResourceRolesToAdminGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGrantResourceRolesToAdminGroupMutation(baseOptions?: Apollo.MutationHookOptions<GrantResourceRolesToAdminGroupMutation, GrantResourceRolesToAdminGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantResourceRolesToAdminGroupMutation, GrantResourceRolesToAdminGroupMutationVariables>(GrantResourceRolesToAdminGroupDocument, options);
      }
export type GrantResourceRolesToAdminGroupMutationHookResult = ReturnType<typeof useGrantResourceRolesToAdminGroupMutation>;
export type GrantResourceRolesToAdminGroupMutationResult = Apollo.MutationResult<GrantResourceRolesToAdminGroupMutation>;
export type GrantResourceRolesToAdminGroupMutationOptions = Apollo.BaseMutationOptions<GrantResourceRolesToAdminGroupMutation, GrantResourceRolesToAdminGroupMutationVariables>;
export const RemoveAdminUsersFromAdminGroupDocument = gql`
    mutation RemoveAdminUsersFromAdminGroup($input: AdminGroupAdminUserMutationInput!) {
  removeAdminUsersFromAdminGroup(input: $input) {
    removedAdminUserIds
  }
}
    `;
export type RemoveAdminUsersFromAdminGroupMutationFn = Apollo.MutationFunction<RemoveAdminUsersFromAdminGroupMutation, RemoveAdminUsersFromAdminGroupMutationVariables>;

/**
 * __useRemoveAdminUsersFromAdminGroupMutation__
 *
 * To run a mutation, you first call `useRemoveAdminUsersFromAdminGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdminUsersFromAdminGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdminUsersFromAdminGroupMutation, { data, loading, error }] = useRemoveAdminUsersFromAdminGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAdminUsersFromAdminGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAdminUsersFromAdminGroupMutation, RemoveAdminUsersFromAdminGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAdminUsersFromAdminGroupMutation, RemoveAdminUsersFromAdminGroupMutationVariables>(RemoveAdminUsersFromAdminGroupDocument, options);
      }
export type RemoveAdminUsersFromAdminGroupMutationHookResult = ReturnType<typeof useRemoveAdminUsersFromAdminGroupMutation>;
export type RemoveAdminUsersFromAdminGroupMutationResult = Apollo.MutationResult<RemoveAdminUsersFromAdminGroupMutation>;
export type RemoveAdminUsersFromAdminGroupMutationOptions = Apollo.BaseMutationOptions<RemoveAdminUsersFromAdminGroupMutation, RemoveAdminUsersFromAdminGroupMutationVariables>;
export const RevokeResourceRolesOfAdminGroupDocument = gql`
    mutation RevokeResourceRolesOfAdminGroup($input: AdminGroupResourceRolesMutationInput!) {
  revokeResourceRolesOfAdminGroup(input: $input) {
    adminGroupId
  }
}
    `;
export type RevokeResourceRolesOfAdminGroupMutationFn = Apollo.MutationFunction<RevokeResourceRolesOfAdminGroupMutation, RevokeResourceRolesOfAdminGroupMutationVariables>;

/**
 * __useRevokeResourceRolesOfAdminGroupMutation__
 *
 * To run a mutation, you first call `useRevokeResourceRolesOfAdminGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeResourceRolesOfAdminGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeResourceRolesOfAdminGroupMutation, { data, loading, error }] = useRevokeResourceRolesOfAdminGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeResourceRolesOfAdminGroupMutation(baseOptions?: Apollo.MutationHookOptions<RevokeResourceRolesOfAdminGroupMutation, RevokeResourceRolesOfAdminGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeResourceRolesOfAdminGroupMutation, RevokeResourceRolesOfAdminGroupMutationVariables>(RevokeResourceRolesOfAdminGroupDocument, options);
      }
export type RevokeResourceRolesOfAdminGroupMutationHookResult = ReturnType<typeof useRevokeResourceRolesOfAdminGroupMutation>;
export type RevokeResourceRolesOfAdminGroupMutationResult = Apollo.MutationResult<RevokeResourceRolesOfAdminGroupMutation>;
export type RevokeResourceRolesOfAdminGroupMutationOptions = Apollo.BaseMutationOptions<RevokeResourceRolesOfAdminGroupMutation, RevokeResourceRolesOfAdminGroupMutationVariables>;
export const UpdateAdminGroupDocument = gql`
    mutation UpdateAdminGroup($id: String!, $input: UpdateAdminGroupInput!) {
  updateAdminGroup(id: $id, input: $input) {
    name
  }
}
    `;
export type UpdateAdminGroupMutationFn = Apollo.MutationFunction<UpdateAdminGroupMutation, UpdateAdminGroupMutationVariables>;

/**
 * __useUpdateAdminGroupMutation__
 *
 * To run a mutation, you first call `useUpdateAdminGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminGroupMutation, { data, loading, error }] = useUpdateAdminGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminGroupMutation, UpdateAdminGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminGroupMutation, UpdateAdminGroupMutationVariables>(UpdateAdminGroupDocument, options);
      }
export type UpdateAdminGroupMutationHookResult = ReturnType<typeof useUpdateAdminGroupMutation>;
export type UpdateAdminGroupMutationResult = Apollo.MutationResult<UpdateAdminGroupMutation>;
export type UpdateAdminGroupMutationOptions = Apollo.BaseMutationOptions<UpdateAdminGroupMutation, UpdateAdminGroupMutationVariables>;
export const UpdateAssessmentOrderDocument = gql`
    mutation UpdateAssessmentOrder($id: String!, $input: UpdateAssessmentOrderInput!) {
  updateAssessmentOrder(id: $id, input: $input) {
    id
    name
    startTimestamp
    endTimestamp
  }
}
    `;
export type UpdateAssessmentOrderMutationFn = Apollo.MutationFunction<UpdateAssessmentOrderMutation, UpdateAssessmentOrderMutationVariables>;

/**
 * __useUpdateAssessmentOrderMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssessmentOrderMutation, { data, loading, error }] = useUpdateAssessmentOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssessmentOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssessmentOrderMutation, UpdateAssessmentOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssessmentOrderMutation, UpdateAssessmentOrderMutationVariables>(UpdateAssessmentOrderDocument, options);
      }
export type UpdateAssessmentOrderMutationHookResult = ReturnType<typeof useUpdateAssessmentOrderMutation>;
export type UpdateAssessmentOrderMutationResult = Apollo.MutationResult<UpdateAssessmentOrderMutation>;
export type UpdateAssessmentOrderMutationOptions = Apollo.BaseMutationOptions<UpdateAssessmentOrderMutation, UpdateAssessmentOrderMutationVariables>;